"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const mark_common_1 = require("@gojipress/mark-common");
const mark_parser_1 = __importDefault(require("@gojipress/mark-parser"));
const codeBlock_1 = __importDefault(require("../../../parsers/block/leaf/codeBlock"));
const splitPaneCustomPlugin = {
    id: "splitPanes",
    name: "Split Panes Custom Plugin",
    pluginType: "custom",
    render: (data) => {
        const parser = new mark_parser_1.default();
        parser.use(codeBlock_1.default);
        const parsedOutput = parser.parse(data);
        const blocks = parsedOutput.children.filter(block => block.type === mark_common_1.GMType.CodeBlock);
        const container = document.createElement("div");
        container.classList.add("gmCustomSplitPanes");
        blocks.forEach(block => {
            const [_, language] = mark_common_1.splitPrefix(block.original.opening, "`");
            const pane = document.createElement("div");
            pane.classList.add("gmCustomSplitPanesPane");
            const paneHeading = document.createElement("div");
            paneHeading.classList.add("gmCustomSplitPanesPaneHeading");
            paneHeading.textContent = language;
            pane.appendChild(paneHeading);
            const paneContent = document.createElement("div");
            paneContent.classList.add("gmCustomSplitPanesPaneContent");
            paneContent.textContent = block.children.map(c => c.original).join();
            pane.appendChild(paneContent);
            container.appendChild(pane);
        });
        return container;
    },
};
exports.default = splitPaneCustomPlugin;
